<template>

  <div class="upload-file-box">
    <a-spin :spinning="loading">
      <a-upload
        name="upload"
        :headers="headers"
        :data="data"
        :before-upload="beforeUpload"
        :custom-request="customRequest"
        :transform-file="transformFile" 
        :multiple="true"
        :file-list="fileList"
        list-type="picture-card"
        :remove="remove"
        @preview="handlePreview"
        @change="handleChange"
        :disabled="!advertiser_id"
      >

        <div v-if="fileList.length < maxNum">
          <a-icon :type="loading ? 'loading' : 'upload'" />
          <div class="ant-upload-text">点击上传</div>
        </div>
      </a-upload>

      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <video  controls style="width: 100%" :src="previewImage" />
      </a-modal>
    </a-spin>

  </div>



 
</template>

<style lang="less" scoped>
@import 'KuaishouUpload';
</style>

<script>
import KuaishouUpload from './KuaishouUpload'
export default KuaishouUpload
</script>
